import {defineDimension, createBooleanMap} from '@webflow-platform/abilities';
import {
  DESIGNER_WORKFLOWS,
  type DesignerWorkflow,
} from '@packages/systems/designer/workflows';

export type WorkflowsConfig = Partial<Record<DesignerWorkflow, boolean>>;
export type WorkflowsStores = {
  DesignerStore?: {workflow?: DesignerWorkflow};
};

export const workflowsDimension = defineDimension<
  WorkflowsConfig,
  WorkflowsStores
>()({
  key: 'workflows',
  isValid(state, config) {
    // Use `in` before reading: partial DesignerStores proxies from
    // `createPartialDesignerStoreForTest` throw on missing keys even with `?.`.
    const currentWorkflow =
      'DesignerStore' in state ? state.DesignerStore?.workflow : undefined;

    return currentWorkflow ? Boolean(config[currentWorkflow]) : true;
  },
  fragments: {
    inWorkflows: (...workflows: DesignerWorkflow[]) =>
      createBooleanMap(workflows, true),
  },
  testMatrix(addAxis) {
    addAxis((addCase) => {
      for (const workflow of Object.values(DESIGNER_WORKFLOWS)) {
        addCase({
          label: `workflow === '${workflow}'`,
          state: {DesignerStore: {workflow}},
        });
      }
    });
  },
});

export const {inWorkflows} = workflowsDimension.fragments;
